import i18next from 'i18next';
import API from 'services/API';

export const login = (creds) => API.post(`/auth/${i18next.language}/login`, creds);

export const forgotPassword = (locale, data) =>
  API.post(`/auth/${locale}/forgotten_password`, data);

export const resetPassword = (token, data) => API.post(`/auth/reset_password/${token}`, data);

export const getPasswordPolicy = (token) =>
  API.get('/auth/password-policy', {
    params: { token },
  });

export const getSsoProviders = () => API.get('/auth/sso/providers');

export const getSsoInitUrl = (provider) =>
  `${API.defaults.baseURL}auth/sso/init?provider=${encodeURIComponent(provider)}`;

export const initSso = async (provider) => {
  const response = await fetch(
    `${API.defaults.baseURL}auth/sso/init?provider=${encodeURIComponent(provider)}`,
    { redirect: 'manual' },
  );

  if (response.type === 'opaqueredirect') {
    const url = response.url || response.headers.get('Location');
    if (url) window.location.href = url;
    return { success: true };
  }

  return { success: false, status: response.status };
};

export default { login, getSsoProviders, getSsoInitUrl, initSso };
